import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import SessionWebinarPlayer from '../../../commonComponents/fileViewers/SessionWebinarPlayer';
import translate from '../../../commonComponents/translate';
import SessionProp from '../propTypes/sessionProp';
import { checkIfHasCreatorAccess, checkIfUserIsInParticipantsList } from '../propTypes/sessionUtils';
import LoggedUserContext from '../../../contextProviders/LoggedUserContext';
import SessionContentDetails from '../classroom/components/SessionContentDetails';

const WebinarContent = props => {
  /** Context */
  const { loggedUser } = useContext(LoggedUserContext);
  const loggedUserId = loggedUser?._id || null;
  /** PROPS */
  const {
    session = {},
    onQRModal,
  } = props;
  const {
    startDate,
  } = session;

  const isUserInParticipants =
    checkIfUserIsInParticipantsList(session, loggedUserId);

  const hasAlreadyStarted = new Date().valueOf() >= new Date(startDate).valueOf();

  const containerClass = 'm-portlet m-portlet--rounded m-portlet--rounded-force' +
    ' m-portlet--full-height session-details-content-container session-content-more-info-container';
  // If user already subscribed or has creator access
  const hasAccessToContent =
    checkIfUserIsInParticipantsList(session, loggedUserId) ||
    checkIfHasCreatorAccess(session, loggedUserId);

  return (
    <>
      {hasAccessToContent && (
        <div className="session-content-active">
          <SessionContentDetails session={session} />
          <div className={containerClass} style={{ minHeight: hasAlreadyStarted ? '420px' : '150px' }}>
            <SessionWebinarPlayer
              webinar={session.webinar}
              session={session}
              handleQRModal={onQRModal}
              isUserInParticipants={isUserInParticipants}
            />
          </div>
        </div>
      )}
    </>
  );
};

WebinarContent.propTypes = {
  onQRModal: PropTypes.func.isRequired,
  session: PropTypes.shape(SessionProp.propType).isRequired,
};
WebinarContent.defaultProps = {};

export default translate(WebinarContent);
